import React, { Component } from 'react';
import '../../../styles/scss/style.css';

//Components

import FormSignUp from './FormSignUp';
import TextHeadingThree from '../atoms/TextHeadingThree';
import TextParagraph from '../atoms/TextParagraph';
import TextBlockquote from '../atoms/TextBlockquote';
import { strings } from '../pages/SignUp/SignUpContent';
var customer = require('../../../images/customer.jpg')


//Returning the component
class SignUp extends Component {

	constructor(props) {
		super(props);
		this.state = {
			myStyle: {
				backgroundImage: 'url(' + this.props.src + ')'
			}
		};
	}
	componentWillReceiveProps(nextProps) {
		this.setState({
			myStyle: {
				backgroundImage: 'url(' + nextProps.image + ')'
			}
		});
	}
	render() {
		return (
			<div className="body">
				<div className="signUp">
					<div className="container">
						<div className="signUp__content">
							<div className="testimonial">
								<div className="testimonial__overlay"></div>
								<div className="testimonial__image" style={{ backgroundImage: "url(" + customer + ")" }}></div>
								<div className="testimonial__quote">
									<TextBlockquote text={strings.signUpTestimonial.textBlockquote} />
									<TextHeadingThree text={strings.signUpTestimonial.textHeadingThree} />
									<TextParagraph type="customer__title" text={strings.signUpTestimonial.textParagraph} />
								</div>
							</div>
							<div className="signUp__form">
								<FormSignUp />
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

export default SignUp;


// WEBPACK FOOTER //
// ./src/redux/components/organisms/SignUp.jsx